import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { createGlobalStyle } from "styled-components"
import Home from "./Pages/Home"
import Header from "./Components/Header"
import { colors } from "./Utils/color"
import WatchMovie from "./Pages/WatchMovie"
import Footer from "./Components/Footer"
import SerieInfos from "./Pages/SerieInfos"
import WatchSerie from "./Pages/WatchSerie"
import ScrollToTop from "./Components/ScrollToTop"
import MoviesList from "./Pages/MoviesList"
import ActRealPage from "./Pages/ActRealPage"
import Search from "./Pages/Search"

const GloabaStyle = createGlobalStyle`
    body {
        font-family: system-ui, -apple-system, BlinkMacSystemFont,
            'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
            'Helvetica Neue', sans-serif;
            color: ${colors.textColor};
        max-width: 100%;
        min-height: 100vh;
        overflow-x: hidden;
        margin: 0;
        background-color: ${colors.backgrond};
        position: relative;
    }
`
/*
function ErrorPage() {
    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h1>Oups !</h1>
            <p>La page demandée est introuvable ou le serveur ne répond pas.</p>
            <a href="/">Retour à l’accueil</a>
        </div>
    )
}
*/

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <GloabaStyle />
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/:fstv" element={<MoviesList />} />
                <Route path="/film/:movieName" element={<WatchMovie />} />
                <Route path="/serie/:serieName" element={<SerieInfos />} />
                <Route path="serie/watch/:serieName" element={<WatchSerie />} />
                <Route path="/:colone/:name" element={<ActRealPage />} />
                <Route path="/rechercher" element={<Search />} />

                {/* Catch-all route pour toute erreur 404 */}
                {/*<Route path="*" element={<ErrorPage />} />*/}
            </Routes>

            <Footer />
        </Router>
    </React.StrictMode>,
    document.getElementById("root"),
)
